import localesPt from '@/shared/i18n/AuthB2C/pt';
import { LOGIN_PAGE_KEY } from '@/views/Login/constants';

const pt = {
  [LOGIN_PAGE_KEY]: {
    ...localesPt,
    SEO_TITLE: 'Conecte-se',
    SEO_DESCRIPTION: 'Inicie a sessão para continuar aprendendo',
    FORM_TITLE: 'Bem-vindo de volta',
    FORM_DESCRIPTION: 'Que bom te ver novamente!',
    FORM_TITLE_RENOVATION: 'Uma surpresa espera por você!',
    FORM_DESCRIPTION_RENOVATION: 'Faça login em sua conta para visualizá-la',
    INPUT_EMAIL_LABEL: 'E-mail',
    INPUT_EMAIL_HINT: 'Digite seu e-mail',
    INPUT_PASSWORD_LABEL: 'Senha',
    INPUT_PASSWORD_HINT: 'Coloque sua senha',
    FORGOT_PASSWORD: 'Esqueceu sua senha?',
    BUTTON_SUBMIT_LABEL: 'Entrar',
    FIRST_TIME_IN_CREHANA: 'É a primeira vez que usa Crehana?',
    REGISTER: 'Cadastrar-se',
    LOGIN_WITH_YOUR_ORGANIZATION: 'Comece com sua organização',
    LOGIN_WITH_YOUR_ORGANIZATION_DESKTOP: 'Faça login com sua organização',
  },
};

export default pt;
